import { postApi } from "./apiService";

// Function to create a banner
export const getPaymentMethods = () => {
    return postApi("/mp/payment/initial-payment");
};